import { ApplicationView } from "@mixitone/mvc";
import ClubPlayerMemberProfile from "components/Pages/Club/ClubPlayer/ClubPlayerMemberProfile";
import { RoutedDrawer } from "components/common/RoutedDrawer";
import { injectModal } from "lib/injectParams";

interface Props {
  clubId: string;
  id: string;
}

const EditPlayer: React.FC<Props> = ({ clubId, id }) => {
  return (
    <RoutedDrawer>
      <ClubPlayerMemberProfile clubId={clubId} id={id} attributes={{}} />
    </RoutedDrawer>
  );
};

export default injectModal(ApplicationView(EditPlayer));
